import React, { useState } from "react";
import AgoraUIKit from "agora-react-uikit";
import { useNavigate } from "react-router-dom";

const VideoCall = () => {
  const [videoCall, setVideoCall] = useState(true);
  const navigate = useNavigate();

  const rtcProps = {
    appId: "f0c775e5d29447a8989960d307998c2c",
    channel: "test",
    token:
      "007eJxTYPg3U1JNRPvMt9Cyiyzv0g4XFgqev/gtbM6JIP+7pr1hev4KDGkGyebmpqmmKUaWJibmiRaWFpaWZgYpxgbmlpYWyUbJs/JSMxoCGRnSdE+wMDJAIIjPwlCSWlzCwAAARbse6w==",
  };

  const callbacks = {
    EndCall: () => {
      setVideoCall(false);
      setTimeout(() => {
        navigate("/dashboard");
      }, 200);
    },
  };

  const rtmProps = {};
  const styleProps = {};

  return videoCall ? (
    <div style={{ display: "flex", width: "100vw", height: "100vh" }}>
      <AgoraUIKit
        rtcProps={rtcProps}
        callbacks={callbacks}
        rtmProps={rtmProps}
        styleProps={styleProps}
      />
    </div>
  ) : null;
};

export default VideoCall;
